import { AfterViewInit, ChangeDetectionStrategy, Component, computed, input, output } from "@angular/core";
import dayjs from "dayjs";
import { DnsFirewallSearchFilter } from "../../../gql/generated";
import { StorageHelper } from "../../../helpers/storage/storagehelper";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { CustomDropdownComponent } from "../../common/custom-dropdown/custom-dropdown";
import { AngularSvgIconModule } from "angular-svg-icon";
import { FormsModule } from "@angular/forms";
import { FlatpickrModule } from "angularx-flatpickr";

@Component({
  selector: "cert-filter-dns",
  templateUrl: "cert-filter.html",
  styleUrls: ["cert-filter.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, CustomDropdownComponent, AngularSvgIconModule, FormsModule, TranslateModule, FlatpickrModule],
})
export class CertFilterDns implements AfterViewInit {
  protected prefixes = input<string[]>([]);
  public filtersChanged = output<DnsFirewallSearchFilter>();

  public initialStartDate: Date = new Date();
  public initialEndDate: Date = new Date();

  public rpzFeedOptions = [
    { id: 1, select: false, name: "Misc", value: "Misc" },
    { id: 2, select: false, name: "Phishing", value: "Phishing" },
    { id: 3, select: false, name: "Malware", value: "Malware" },
    { id: 4, select: false, name: "SURFcert MISP", value: "SURFcert MISP" },
  ];
  public ip = "";

  public prefixOptions = computed(() =>
    this.prefixes()
      .map((prefix: string, index: number) => ({
        id: index,
        select: false,
        name: prefix,
      }))
      .sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        return nameA.localeCompare(nameB);
      }),
  );

  constructor() {
    this.initialStartDate.setDate(this.initialStartDate.getDate() - 7);
  }

  submit() {
    this.filtersChanged.emit(this.searchFilter());
  }

  searchFilter(): DnsFirewallSearchFilter {
    const filter: DnsFirewallSearchFilter = {
      customerId: StorageHelper.currentUser,
      beforeRecordedAt: dayjs(this.initialEndDate).endOf("day").toDate(),
      afterRecordedAt: dayjs(this.initialStartDate).startOf("day").toDate(),
    };

    const selectedPrefixes = this.prefixOptions().filter((prefix) => prefix.select);
    const selectedClassifications = this.rpzFeedOptions.filter((rpz) => rpz.select);

    if (selectedPrefixes.length) {
      filter.ipPrefixes = selectedPrefixes.map((prefix) => prefix.name as string);
    }

    if (selectedClassifications.length) {
      filter.rpzFeed = selectedClassifications.map((rpz) => rpz.value);
    }

    if (this.ip !== "") {
      filter.ipAddress = `${this.ip}`.trim().replace(/[^0-9.]/g, "");
    }

    return filter;
  }

  ngAfterViewInit(): void {
    this.filtersChanged.emit(this.searchFilter());
  }

  resetFilters() {
    this.ip = "";

    this.prefixOptions().forEach((prefix) => {
      prefix.select = false;
    });

    this.rpzFeedOptions.forEach((rpz) => {
      rpz.select = false;
    });

    this.initialStartDate = dayjs().subtract(7, "day").startOf("day").toDate();
    this.initialEndDate = dayjs().endOf("day").toDate();

    this.filtersChanged.emit(this.searchFilter());
  }
}
